<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h38orT/tc-custom/9781488029950.jpg?1708749524843" alt="This image is the cover for the book Twelfth Night, The Lady Julia Grey Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Twelfth Night, The Lady Julia Grey Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>An amateur sleuth and her detective husband probe the mystery of an abandoned baby and eerie legend in the Victorian English countryside in this novella.</b><br/><br/>To mark the passing of another decade, the esteemed—and eccentric—March family have assembled at Bellmont Abbey to perform the Twelfth Night Revels for their sleepy English village. But before Lady Julia and her handsome, sleuthing husband, Nicolas Brisbane, can take to the stage, a ruckus in the stable yard demands their attention. An abandoned infant is found nestled in the steel helm of St. George. What’s more, their only lead is the local legend of a haunted cottage and its ghastly inhabitant—who seems to have returned.<br/><br/>Once again, Lady Julia and Nicholas take up the challenge to investigate, and when the source of the mystery is revealed, they’ll be faced with an impossible choice—one that will alter the course of their lives . . . forever.<br/><br/><i>Previously published.</i><br/><br/>Don’t miss the complete Lady Julia Grey mystery series by <i>New York Times</i>–bestselling author Deanna Raybourn!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deanna Raybourn
      </h2>
      
      <p class="authorDescription body article">New York Times bestselling author Deanna Raybourn graduated from the University of Texas at San Antonio with a double major in English and history and an emphasis on Shakespearean studies. She taught high school English for three years in San Antonio before leaving education to pursue a career as a novelist. Deanna makes her home in Virginia, where she lives with her husband and daughter and is hard at work on her next novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78eca682